import { SendData, TrackEventData } from './raygun.types';

/**
 * The Raygun4JS client library to send tracking events to Raygun4JS for monitoring frontend performance and tracking errors / logs.
 *
 * This should not be used
 * @param key - The action to perform, e.g., 'trackEvent'.
 * @param value - The object of event, e.g., `{ metadata: { state: isLoading: true }}`.
 *
 * This should not be used directly. Instead, please use the logger. It will use this function to log client-side errors.
 */
function rg4js(key: 'send', value: SendData): void;
function rg4js(key: 'trackEvent', value: TrackEventData): void;
function rg4js(
  key: 'send' | 'trackEvent',
  value: SendData | TrackEventData,
): void {
  if (window.rg4js) {
    window.rg4js(key, value);
  } else {
    console.error('rg4js is not available in the window object.');
  }
}

export { rg4js };
